import { DocumentNode } from 'apollo-link';
import gql from "graphql-tag";
import { CustomSqlFragmentGql } from './CustomSqlFragmentGql';

export const WorkbookCustomSqlQueryGql: DocumentNode = gql`
  query WorkbookCustomSqlQuery(
    $vizportalUrlId: String!,
    $selectedEmbeddedDatasourceId: ID!
  ) {
    workbooks(filter: { vizportalUrlId: $vizportalUrlId }) {
      embeddedDatasources(filter: { id: $selectedEmbeddedDatasourceId }) {
        name
        ...CustomSqlFragment
      }
    }
  }
  ${CustomSqlFragmentGql}
`;
